import { Avatar, Button, Drawer, Icon, Radio, Table, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { getNumberWithoutSpaces } from "../../../../../common/utils/format";
import { useDispatch, useSelector } from "react-redux";
import { API } from "../../../../../common/api/constants";
import Spinner from "../../../../../common/components/spinner/Spinner";
import TablePageSize from "../../../../../common/components/TablePageSize";
import { getDrivers } from "../../../../Employees/redux/actions/profiles";
import {
  assignDriver,
  setAssignDriverDrawerVisibility
} from "../../redux/actions/orderCard";

const { Text } = Typography;

let tablePlaceholder = <Icon type="loading" style={{ fontSize: 44 }} spin />;

const DriversTable = props => {
  useEffect(() => {
    dispatch(getDrivers());
  }, []);
  const [pages, setPages] = useState(3);
  const dispatch = useDispatch();
  const employees = useSelector(state => state.Employees.profiles);
  const driversList = employees && employees.drivers;
  function renderColumns() {
    return [
      {
        title: "",
        dataIndex: "driver",
        key: "photo",
        render: (_, driver) => (
          <>
            {driver.photo ? (
              <img
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "4px",
                  cursor: "pointer"
                }}
                src={`${API.replace("/api", "")}${driver.photo}`}
                alt=""
              />
            ) : (
              <Avatar shape="square" size="large" icon="user" />
            )}
          </>
        )
      },
      {
        title: "ФИО",
        dataIndex: "driver",
        key: "fio",
        width: "50%",
        render: (_, driver) => (
          <span>
            {driver.lastname && driver.lastname} <br />{" "}
            <Text type="secondary">
              {driver.name && driver.name}{" "}
              {driver.patronymic && driver.patronymic}
            </Text>
          </span>
        ),
        sorter: (a, b) => {
          return a.driver.lastname.localeCompare(b.driver.lastname);
        }
      },
      {
        title: "Дата и время окончания последнего заказа",
        dataIndex: "driver",
        key: "orderInfo",
        width: "50%"
      }
    ];
  }
  function changePaginationSize(e) {
    setPages(Number(e));
  }
  function onRow(row) {
    return {
      onClick: () => {
        dispatch(
          assignDriver({
            driver_id: row.id,
            offer_id: props.data && props.data.offerId
          })
        );
      }
    };
  }
  if (employees.isLoading) {
    return <Spinner />;
  }
  return (
    <div className="basicForm">
      <div className="drivers">
        <div className="drivers__header">
          <div className="drivers__types">
            <Radio.Group defaultValue="active" size="large">
              <Radio.Button>
                Водители: {driversList && driversList.length}
              </Radio.Button>
            </Radio.Group>
          </div>
        </div>
        <div className="drivers__wrap">
          <div className="employees__table">
            <Table
              dataSource={driversList}
              pagination={{
                pageSize: pages
              }}
              locale={{
                emptyText: employees.isLoading
                  ? tablePlaceholder
                  : "Водителей нет"
              }}
              onRow={onRow}
              rowKey="id"
              columns={renderColumns()}
            />
            {driversList && driversList.length > 0 ? (
              <TablePageSize
                pages={pages}
                changePaginationSize={changePaginationSize}
              />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

const OrderAssignDriver = props => {
  const isVisible = useSelector(
    state => state.Executorship.Orders.orderCard.assignDriverDrawerIsVisible
  );
  const dispatch = useDispatch();

  return (
    <>
      <Button
        type="primary"
        ghost
        size="large"
        onClick={() => {
          dispatch(setAssignDriverDrawerVisibility(true));
        }}
      >
        {props.isDrivers ? "Сменить водителя" : "Назначить водителя"}
      </Button>
      <Drawer
        visible={isVisible}
        closable={true}
        onClose={() => {
          dispatch(setAssignDriverDrawerVisibility(false));
        }}
        destroyOnClose={true}
        placement={"left"}
        width={896}
        className={"assign-driver-drawer"}
      >
        <div className={"drawer-header"}>
          <span className={"drawer-header__title"}>
            {" "}
            {props.isDrivers ? "Сменить водителя" : "Назначить водителя"}
          </span>
          <span className={"drawer-header__number"}>
            {props.data && props.data.number
              ? `Заказ – ${getNumberWithoutSpaces(props.data.number)}`
              : null}
          </span>
        </div>
        <DriversTable data={props.data} />
        <div className={"drawer-footer"} />
      </Drawer>{" "}
    </>
  );
};

export default OrderAssignDriver;
